import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import '../csscomponent/Home.css';
import { getCmsSettings } from '../lib/sqlAuth';
import { subscribeCmsUpdates } from '../lib/cmsSync';
import CoinEffects from './CoinEffects';
import AdMobBanner from './AdMobBanner';
import { showInterstitialAd } from '../lib/admobService';

export default function HomePage() {
  const [content, setContent] = useState({
    kicker: 'Digital Product Studio',
    title: 'Build smarter websites, products, and growth engines.',
    subtitle: 'We design and develop conversion-focused web experiences for startups and modern businesses.',
    stats: [
      { value: '120+', label: 'Projects Delivered' },
      { value: '95%', label: 'Client Retention' },
      { value: '24/7', label: 'Support Coverage' },
    ],
  });

  useEffect(() => {
    let mounted = true;
    const loadHome = () => {
      getCmsSettings({ keys: ['hero_content'] })
        .then((res) => {
          const c = res?.settings?.hero_content || {};
          if (!mounted) return;
          setContent((prev) => ({
            kicker: c.kicker || prev.kicker,
            title: c.title || prev.title,
            subtitle: c.subtitle || prev.subtitle,
            stats: Array.isArray(c.stats) && c.stats.length > 0 ? c.stats : prev.stats,
          }));
        })
        .catch(() => {});
    };

    loadHome();
    const unsubscribe = subscribeCmsUpdates(() => loadHome());
    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  return (
    <section className="home-banner" id="home">
      <div className="home-overlay" />
      <div className="home-content">
        <motion.div
          className="home-copy"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="home-kicker">{content.kicker}</p>
          <h1>{content.title}</h1>
          <p className="home-subtitle">
            {content.subtitle}
          </p>
          <div className="home-cta">
            <Link to="/services" className="home-btn primary" onClick={() => showInterstitialAd()}>Explore Services</Link>
            <Link to="/product" className="home-btn secondary" onClick={() => showInterstitialAd()}>See Products</Link>
          </div>
          <div className="home-stats">
            {content.stats.map((item, index) => (
              <motion.div
                key={`${item.label}-${item.value}`}
                className="home-stats-card"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: 0.18 + (index * 0.08) }}
              >
                <span className="home-stats-chip">0{index + 1}</span>
                <strong>{item.value}</strong>
                <span className="home-stats-label">{item.label}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="home-coin-side"
          initial={{ opacity: 0, x: 30, scale: 0.96 }}
          whileInView={{ opacity: 1, x: 0, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.75, delay: 0.15, ease: 'easeOut' }}
        >
          <CoinEffects
            centerText="S&D"
            label=""
            className="home-coin"
          />
        </motion.div>
      </div>

      <div className="home-ad-wrapper">
        <AdMobBanner
          className="home-inline-ad"
          title="Services & Developer Showcase"
          subtitle="Sponsored Web & Mobile Cloud Technologies"
        />
      </div>
    </section>
  );
}
